SlideView = require("views/slide")
{ Sound } = Application.actions()

class ImageMapView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"
    "iostap .waypoint": "tapWaypoint"
    "iostap": "exitWaypoint"

  serialize: ->
    data = super
    data.hasPrompt = true

    for waypoint in data.waypoints
      waypoint.center = @getCenter(waypoint.region)

    data

  submit: (e) ->
    e?.stopImmediatePropagation()
    super

  beforeHide: ->
    @trigger("ui", lightbox: false)
    Sound.fadeOut(@currentSrc, 500, 0.02) if @currentSrc

  hide: ->
    @exitWaypoint()
    @el.classList.remove("is-loaded")

  refresh: (params) ->
    for { caption }, i in params.data.waypoints
      changed = i unless caption is @options.data.waypoints[i]?.caption

    super

    @beforeShow()
    @show(false)

    if changed?
      @el.classList.add "no-transition"
      @goToWaypoint(changed)
      _.delay (=> @el.classList.remove "no-transition"), 1

  onRefresh: ->

  onResize: ->
    @getEl("waypoints").removeAttribute("style")
    @setContainerDimensions()

  beforeShow: ->
    @setState(false, "zoom")
    @setState(@options.data.stickyCaptions, "sticky")
    @setState(@options.data.zoom.toString(), "recenter")

  setTextColor: (lightbox) ->
    if color = lightbox?.textColor?.toLowerCase()
      @el.style.color = lightbox?.textColor?.toLowerCase()

  setWaypointColor: (appearance) ->
    if color = appearance?.waypointColor?.toLowerCase()
      # Remove all existing style-option classes
      @el.classList.remove("waypoint-none", "waypoint-black", "waypoint-white")
      @el.classList.add("waypoint-#{color}")

  showLightbox: ->
    @setState(true, "zoom")
    @trigger("ui", lightbox: @options.data.lightbox?.background or true)

  show: (fadeImage = true) ->
    @setEl img = @findOne(".img-map"), "image"
    return unless img?
    @setEl @findOne(".caption"), "caption"
    @setEl @findOne(".waypoints"), "waypoints"
    @setEl @findOne(".navigation"), "navigation"
    @setEl @findOne(".image-container"), "container"
    @setEl @findAll(".waypoint-img"), "images"

    @setState("prompt")
    @setState(false, "zoom")

    @setTextColor(@options.data.lightbox)
    @setWaypointColor(@options.data.appearance)
    @listenTo this, "resize", @onResize

    if not fadeImage
      @el.classList.add "no-transition"

    if img?.complete
      @setDimensions()
    else if img?
      img.onload = => @setDimensions()

  setDimensions: ->
    @setContainerDimensions()
    @el.classList.add("is-loaded")

    @el.offsetLeft
    @el.classList.remove "no-transition"
    @scaleDown(i) for waypoint, i in @options.data.waypoints

  getCenter: (wp) ->
    x: (wp.xMin + wp.xMax) / 2
    y: (wp.yMin + wp.yMax) / 2

  allWaypointsTapped: ->
    _.reduce @getEl("waypoints").children, (allTapped, el) ->
      allTapped and el.dataset.tapped
    , true

  tapWaypoint: (e) ->
    el = e.target
    e.stopImmediatePropagation()

    @goToWaypoint +el.dataset.index

    el.dataset.tapped = "true"
    el.classList.add "tapped"

    if @allWaypointsTapped()
      @setState("touched")

  limits: ->
    min: 0
    max: @options.data.waypoints.length - 1

  goToWaypoint: (@currentIndex) ->
    { region, caption, narration } = @options.data.waypoints[@currentIndex]
    loaded = false

    Sound.stop(@currentSrc) if @currentSrc
    if (@currentSrc = narration) and not @withoutNarration
      @showLoadingNarration()
      Sound.play narration,
        cb: =>
        onProgress: =>
          unless loaded
            loaded = true
            @hideLoadingNarration()

    @getEl("images").item(@currentIndex).classList.add("active")

    @showLightbox()
    @toggleCaption(caption)
    @scaleUp(@currentIndex)

  exitWaypoint: ->
    return unless @currentIndex?

    Sound.fadeOut(@currentSrc, 500, 0.02) if @currentSrc

    @getEl("images").item(@currentIndex).classList.remove("active")
    @toggleCaption()
    @setState(false, "zoom")
    @trigger("ui", lightbox: false)
    @scaleDown(@currentIndex)
    @transform @getEl("image"), scale: 1, y: "-50%"
    @transform @getEl("navigation"), y: 0

    delete @currentIndex

  scaleDown: (index) ->
    wimage   = @getEl("images").item(index)
    scale    = 1 / @scaleForWaypoint(@options.data.waypoints[index])
    waypoint = @getEl("waypoints").children[index]

    if @options.data.zoom
      top  = (wimage.offsetHeight - @getEl("waypoints").offsetHeight) / 2
      left = @getEl("waypoints").parentNode.offsetLeft

      x = (waypoint.offsetLeft + waypoint.offsetWidth / 2) -
          (wimage.offsetWidth / 2 - left)

      y = (waypoint.offsetTop + waypoint.offsetHeight / 2) -
          (wimage.offsetHeight / 2 - top) -
          (wimage.offsetTop)

    else
      x     = 0
      y     = "-50%"
      scale = 1

    @transform wimage, { x, y, scale }

  scaleUp: (index) ->
    waypoint  = @options.data.waypoints[index]
    nav       = @getEl("navigation")
    image     = @getEl("image")
    wimage    = @getEl("images").item(index)
    wHeight   = wimage.offsetHeight
    wTop      = (window.innerHeight - wHeight) / 2

    yOffset   = -nav.offsetHeight / 2 / image.height
    yOffset  *= 0.75
    iOffset   = yOffset * image.offsetHeight

    if @options.data.zoom
      { x, y }  = @getCenter(waypoint.region)
      scaleToUse = @scaleForWaypoint(waypoint)
    else
      x = 0.5
      y = 0.5
      scaleToUse = 1

    @transform image,
      x: scaleToUse * 100 * (0.5 - x) + "%"
      y: -50 + yOffset * 100 + scaleToUse * 100 * (0.5 - y) + "%"
      scale: scaleToUse

    @transform wimage,
      y: -50 + (100 * iOffset / wHeight) + "%"
      scale: 1

    if @options.data.stickyCaptions
      img  = wimage.firstChild
      navY = nav.offsetTop - wTop
      imgY = img.offsetTop + img.offsetHeight / 2 + iOffset
      offY = -Math.max navY - imgY, 0
      @transform nav, y: offY

  scaleForWaypoint: (waypoint) ->
    if @options.data.zoom
      index     = @options.data.waypoints.indexOf(waypoint)
      {region}  = waypoint
      image     = @getEl("image")
      wp        = @getEl("waypoints").children[index]
      wimage    = @getEl("images").item(index)
      navBounds = @getEl("navigation").getBoundingClientRect()

      viewportWidth  = wimage.firstChild.offsetWidth
      viewportHeight = wimage.firstChild.offsetHeight
      regionWidth    = (region.xMax - region.xMin) * image.offsetWidth
      regionHeight   = (region.yMax - region.yMin) * image.offsetHeight
      widthScale     = viewportWidth / regionWidth
      heightScale    = viewportHeight / regionHeight
      scaleToUse     = Math.min widthScale, heightScale
    else
      scaleToUse = 1

  toggleCaption: (caption = false) ->
    @setState(Boolean(caption), "caption")
    @getEl("caption").innerHTML = caption if caption

    if not caption?
      @getEl("caption").style.background = ""
    else if @options.data.lightbox?.background
      @getEl("caption").style.background = @options.data.lightbox.background

  setContainerDimensions: ->
    @getEl("waypoints").style.height = "#{@getEl("image").offsetHeight}px"
    @getEl("waypoints").style.width  = "#{@getEl("image").offsetWidth}px"


module.exports = ImageMapView
